<div class="ziti-page-container ziti-terminators-container">
  <lib-list-page-header [title]="title"
    [tabs]="tabs"
    [hideAction]="true"
    [blockCreate]="headerBlockCreate"
    [blockDelete]="headerBlockDelete"
  (actionClicked)="headerActionClicked($event)"></lib-list-page-header>
  <lib-data-table [tableId]="'terminators'"
    [noItemsReadonly]="headerBlockCreate"
    [accessDenied]="headerBlockRead"
    [rowData]="rowData"
    [isLoading]="isLoading"
    [columnDefinitions]="columnDefs"
    (actionRequested)="tableAction($event)"
    [startCount]="startCount"
    [endCount]="endCount"
    [totalCount]="totalCount"
    [emptyMsg]="'No terminators defined, Click the plus to add a terminator.'"
    [filterApplied]="filterApplied"
    [filterName]="'Address'"
    [filterColumn]="'address'"
    [menuItems]="svc.menuItems"
    (gridReady)="gridReady($event)"
    [options]="{noSelect: true, noMenu: false}"
    >
  </lib-data-table>
</div>
@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
